
export default "/assets/save.45c86b8d.svg"